import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_1W_9_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_29_99_1w_9_99_usd',
			ARS: 'simple_premium_4w_39990_1w_12990_ars',
			COP: 'simple_premium_4w_119990_1w_39990_cop',
			CLP: 'simple_premium_4w_29990_1w_9990_clp',
		},
		primer: 'prd_ReH5JMB05sB7',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 9.99,
			EUR: 9.99,
			GBP: 9.99,
			AUD: 15.99,
			CAD: 15.99,
			DKK: 79,
			SEK: 119,
			NOK: 119,
			BRL: 49.99,
			MXN: 169,
			TRY: 299,
			ARS: 12990,
			COP: 39990,
			CLP: 9990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			SEK: 399,
			NOK: 399,
			BRL: 199.99,
			MXN: 499,
			TRY: 999,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
}
